/**
 * Единственное место во всей системе, где разрешён проп style.
 *
 * Нужен для величин, которые известны только во время выполнения:
 * выбранный пользователем цвет, вычисленный размер, доля прогресса.
 * Такие значения передаются как CSS-переменные, а сами стилевые
 * решения остаются в таблице стилей — компонент лишь подставляет число.
 *
 * Пример:
 *   <Vars as="button" vars={{ '--swatch': color }} className="swatch" />
 *
 * Если появляется желание передать сюда готовое свойство
 * (padding, display, color) — это признак, что нужен класс, а не Vars.
 */
export function Vars({ as: Tag = 'div', vars, children, ...rest }) {
  // eslint-disable-next-line react/forbid-dom-props -- см. описание модуля
  return (
    <Tag style={vars} {...rest}>
      {children}
    </Tag>
  )
}
